import { render } from "./CharactersFilter.vue?vue&type=template&id=6a70ead4"
import script from "./CharactersFilter.vue?vue&type=script&lang=ts"
export * from "./CharactersFilter.vue?vue&type=script&lang=ts"

import "./CharactersFilter.vue?vue&type=style&index=0&id=6a70ead4&lang=scss"
script.render = render

export default script